import { render, staticRenderFns } from "./tbyxxsc.vue?vue&type=template&id=11299a4c&"
import script from "./tbyxxsc.vue?vue&type=script&lang=js&"
export * from "./tbyxxsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports